import { useState, useEffect } from 'react';
import { poolInformation, useAprGuaranteedValues } from 'src/config';
import { decodeBase64Value, handleUnexpectedException } from 'src/helpers/functions';
import { networkProvider } from 'src/utils/networkProvider';
import { smartContract } from 'src/utils/smartContract';

function useApr(stakingType) {
    const [apr, setApr] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchApr = async () => {
            try {
                const interaction = smartContract.methods.getApr([stakingType]);
                const query = interaction.check().buildQuery();
                const queryResponse = await networkProvider.queryContract(query);
                const aprValue = queryResponse.returnData[0] || 0;

                setApr(decodeBase64Value(aprValue) / 100);
            } catch (err) {
                handleUnexpectedException(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (stakingType) {
            if (useAprGuaranteedValues) {
                return setApr(poolInformation[stakingType.discriminant].guaranteedApr);
            }

            fetchApr();
        }
    }, [stakingType]);

    return { apr, loading, error };
}

export default useApr;
